module.exports = __webpack_public_path__ + "img/team-dude.ab548bda.svg";